export interface BrowserDownload {
  readonly blob: Blob;
  readonly filename: string;
}

export function downloadBrowserFile(file: BrowserDownload): string {
  const objectUrl = URL.createObjectURL(file.blob);
  const anchor = document.createElement('a');
  anchor.download = file.filename;
  anchor.href = objectUrl;
  anchor.hidden = true;
  document.body.append(anchor);
  try {
    anchor.click();
  } catch (cause) {
    throw new Error('The browser could not start the download.', { cause });
  } finally {
    anchor.remove();
    window.setTimeout(() => URL.revokeObjectURL(objectUrl), 0);
  }
  return file.filename;
}
